import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'

const routeGoogleSettingsHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/settings/interfaces/ViewInterfaces.vue')
  },
  meta: { doctypes: { [DOCTYPES.GOOGLE_SETTINGS]: [PERMISSIONS.READ] } },
  name: 'google-settings',
  path: '',
}

export { routeGoogleSettingsHome }
